import { AppUtils } from '.';

export class Data {
    public static deployUrl = '';

    public static getImageUrl(image: string): string {
        return this.deployUrl + 'assets/img/' + image;
    }

    public static getFlagImageUrl(flagRegistryId: number): string {
        return (
            this.deployUrl +
            `assets/img/flags/${flagRegistryId || 'generic'}.png`
        );
    }

    static get emailRegex(): string {
        return '^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$';
    }

    static validEmail(s: string): boolean {
        return new RegExp(this.emailRegex).test(s);
    }

    static validPhone(s: string, numbers = 0): boolean {
        if (numbers) {
            if (!s?.length) return false;
            const phoneDigits: string = s.substring(1);
            if (
                s[0] == '+' &&
                phoneDigits.length == numbers &&
                [...phoneDigits].every((c) => '0123456789'.includes(c))
            )
                return true;
            return false;
        }
        return true;
    }

    static validPhoneAny(s: string, numbers = 0): boolean {
        return new RegExp(
            `^[A-Za-z0-9_@./#&+-]${numbers > 0 ? `{${numbers}}` : '*'}$`
        ).test(s);
    }

    static get passwordRegex(): string {
        return '^(?=.*[0-9])(?=.*[A-Z])[a-zA-Z0-9!_\\-@#$%^&*]{8,28}$';
    }

    static isObjectEmpty(obj: any): boolean {
        return Object.keys(obj).length === 0;
    }

    static getValueByPath(object: any, path: string): any {
        const parts: string[] = path.split('.');
        let value: any;
        let index: number;

        for (value = object, index = 0; value && index < parts.length; ++index)
            value = value[parts[index]];

        return value;
    }

    //#region Check object changes

    static getKeys(...vals: any[]): string[] {
        const keys: string[] = [];
        (vals || []).forEach((v) => {
            Object.keys(v || {}).forEach((p) => {
                if (!keys.includes(p)) keys.push(p);
            });
        });
        return keys;
    }

    static isPrimitiveValue(val: any): boolean {
        if (val === undefined || val === null) return true;
        if (val instanceof Date) return true;
        else if (val instanceof Object) return false;
        else return true;
    }

    static getPrimitiveValue(val: any): string {
        if (val === undefined || val === null) return '';
        if (val instanceof Date)
            return AppUtils.DateTime.GetDateTimeStringWithSecond(val);
        else if (val instanceof Object) return 'Object';
        else return val.toString();
    }

    //#endregion

    //like selectMany in C# : [[1, 2], [3, 4]] => [1, 2, 3, 4]
    static selectMany(list: any[][]): any[] {
        return !list?.length
            ? []
            : list.length == 1
            ? list[0]
            : list.reduce((a, b) => a.concat(b));
    }

    public static getCamelCase(str: string): string {
        let hasLowerCase = false;
        let r = '';
        for (let i = 0; i < str.length; i++) {
            const c = str[i];
            if (hasLowerCase) r += c;
            else {
                const lc = c.toLowerCase();
                hasLowerCase = c === lc;
                r += hasLowerCase ? c : lc;
            }
        }
        return r;
    }

    public static getCamelCaseAndRemoveSpace(str: string): string {
        return (
            str
                ?.toLowerCase()
                // Replaces any - or _ characters with a space
                .replace(/[-_]+/g, ' ')
                // Removes any non alphanumeric characters
                .replace(/[^\w\s]/g, '')
                // Uppercases the first character in each group immediately following a space
                // (delimited by spaces)
                .replace(/ (.)/g, function ($1) {
                    return $1?.toUpperCase();
                })
                // Removes spaces
                .replace(/ /g, '')
        );
    }

    public static arraysAreEqual(
        list1: any[],
        list2: any[],
        isSimple = true,
        isOrdered = false
    ): boolean {
        if (list1?.length != list2?.length) return false;
        if (isSimple)
            return isOrdered
                ? list1?.every((x, i) => x === list2[i])
                : list1?.every((x) => list2?.find((y) => x === y));
        return list1?.every((x) =>
            list2?.find((y) => this.arraysAreEqual(x, y, true, isOrdered))
        ); // deal with [[],[],[]] at most, not further nested ones
    }

    public static copyLargeArray<T>(arrTo: T[], arrSource: T[]) {
        for (let i = 0; i < arrSource.length; i += 10000) {
            arrTo.push(...arrSource.slice(i, i + 10000));
        }
    }

    public static isGuid(str: string): boolean {
        const guidRegex =
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89ABab][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$/;
        return guidRegex.test(str);
    }
}
